// This constant should be used on all requests that include a body (i.e. PATCH or POST requests)
export const headers = (typeof Headers !== "undefined") ? new Headers({
  'Content-Type': 'application/json',
}) : {};

